import React, { useRef } from "react";

export const PhotoUploadInput = ({
  label,
  preview,
  onChange,
  accept = "image/*",
  helpText = "Upload an Image",
}) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange(file, reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="sm:col-span-4">
      <label className="block text-sm text-center font-medium leading-6 text-gray-500 dark:text-gray-400">
        {label}
      </label>
      <div className="mt-1 flex justify-center">
        <div className="relative inline-block">
          {preview ? (
            <>
              <img
                src={preview}
                alt={label}
                onClick={handleClick}
                className="h-32 w-32 rounded-full object-cover border-[8px] border-primary"
              />
              <button
                type="button"
                onClick={handleClick}
                className="absolute top-2 right-0 -translate-y-1 w-6 h-6 rounded-full bg-primary hover:bg-primaryDark transition-colors flex items-center justify-center shadow-lg"
                title="Edit photo"
              >
                <svg
                  className="w-4 h-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </button>
            </>
          ) : (
            <>
              <div
                onClick={handleClick}
                className="h-32 w-32 rounded-full border-[8px] border-primary bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors flex items-center justify-center cursor-pointer group"
                title="Upload photo"
              >
                <svg
                  className="w-16 h-16 text-gray-400 dark:text-gray-500 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-colors"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              </div>
              <button
                type="button"
                onClick={handleClick}
                className="absolute top-2 right-0 -translate-y-1 w-6 h-6 rounded-full bg-primary hover:bg-primaryDark transition-colors flex items-center justify-center shadow-lg"
                title="Upload photo"
              >
                <svg
                  className="w-4 h-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </button>
            </>
          )}
          <input
            ref={fileInputRef}
            type="file"
            accept={accept}
            onChange={handleFileChange}
            className="hidden"
          />
        </div>
      </div>
    </div>
  );
};
